import { loadProfile } from '../content/loadProfile'

export default function ContactSection() {
  const profile = loadProfile()
  const mailto = `mailto:${profile.contactEmail}`

  return (
    <section id="contact" data-testid="contact" className="section section--contact">
      <h2>Contact</h2>
      <p>
        <a href={mailto} data-testid="contact-mailto">
          Email {profile.displayName}
        </a>
      </p>
      <p data-testid="contact-email">{profile.contactEmail}</p>
      {profile.linkedInUrl ? (
        <p>
          <a
            href={profile.linkedInUrl}
            data-testid="contact-linkedin"
            rel="noopener noreferrer"
            target="_blank"
          >
            LinkedIn
          </a>
        </p>
      ) : null}
      {profile.secondaryContactNote ? (
        <p data-testid="contact-note">{profile.secondaryContactNote}</p>
      ) : null}
    </section>
  )
}
